var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 87 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrations/States/ Reservation Number@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "reservation-number-path-1",
    cx: 41.1428571,
    cy: 41.1428571,
    r: 41.1428571
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "103.411666%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trip-Q4-2019-1st-Dev-Hand-off-desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TripMgr-ResDetailLand-upcoming-blockers-pristine",
    transform: "translate(-280.000000, -732.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(261.000000, 717.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrations/States/-Reservation-Number",
    transform: "translate(16.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EDF0F2",
    fillRule: "nonzero",
    cx: 48,
    cy: 48.2742857,
    r: 41.1428571
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-+-Path-+-#-Mask",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(6.857143, 7.131429)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "reservation-number-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reservation-number-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "reservation-number-Mask",
    fill: "#EDF0F2",
    fillRule: "nonzero",
    xlinkHref: "#reservation-number-path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    fill: "#E6EAEC",
    mask: "url(#reservation-number-mask-2)",
    points: "67.6347103 17.5542857 82.2857143 32.2052897 82.2857143 82.3542857 13.0285714 82.3542857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0285714,17.5542857 L66.2571429,17.5542857 C67.9139971,17.5542857 69.2571429,18.8974315 69.2571429,20.5542857 L69.2571429,82.3542857 L69.2571429,82.3542857 L13.0285714,82.3542857 L13.0285714,20.5542857 C13.0285714,18.8974315 14.3717172,17.5542857 16.0285714,17.5542857 Z",
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    mask: "url(#reservation-number-mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0285714,17.5542857 L66.2571429,17.5542857 C67.9139971,17.5542857 69.2571429,18.8974315 69.2571429,20.5542857 L69.2571429,27.1542857 L69.2571429,27.1542857 L13.0285714,27.1542857 L13.0285714,20.5542857 C13.0285714,18.8974315 14.3717172,17.5542857 16.0285714,17.5542857 Z",
    id: "Rectangle",
    fill: "#9CADB5",
    fillRule: "nonzero",
    mask: "url(#reservation-number-mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2728515,20.8694607 L54.2715942,19.6114286 L51.2516129,21.7488008 L54.2715942,23.886676 L54.2728515,22.6356846 C55.7813334,22.6291467 56.6284871,23.0885561 57.2973589,24.3888328 L57.537499,24.3340154 C57.537499,22.1626967 56.4104752,20.8689578 54.2728515,20.8694607",
    id: "Path",
    fill: "#FFFFFF",
    mask: "url(#reservation-number-mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9168,43.9186286 L15.9168,42.6898286 L16.9536,42.6898286 L17.1168,41.8930286 L16.3104,41.8930286 L16.3104,40.6546286 L17.3664,40.6546286 L17.7216,38.9266286 L19.0368,38.9266286 L18.6816,40.6546286 L19.3536,40.6546286 L19.7088,38.9266286 L21.0144,38.9266286 L20.6592,40.6546286 L21.4464,40.6546286 L21.4464,41.8930286 L20.4096,41.8930286 L20.2464,42.6898286 L21.0432,42.6898286 L21.0432,43.9186286 L19.9968,43.9186286 L19.6416,45.6466286 L18.3264,45.6466286 L18.6816,43.9186286 L18.0096,43.9186286 L17.6544,45.6466286 L16.3488,45.6466286 L16.704,43.9186286 L15.9168,43.9186286 Z M18.2592,42.6898286 L18.9312,42.6898286 L19.0944,41.8930286 L18.4224,41.8930286 L18.2592,42.6898286 Z M26.1517714,44.3698286 L26.1517714,45.6466286 L22.2157714,45.6466286 L22.2157714,44.3698286 L23.4253714,44.3698286 L23.4253714,40.5202286 L22.2349714,41.0674286 L22.2349714,39.6850286 L23.6077714,38.9266286 L24.9517714,38.9266286 L24.9517714,44.3698286 L26.1517714,44.3698286 Z M27.2763429,45.6466286 L27.2763429,44.3698286 L29.1867429,42.4498286 C29.7723429,41.8642286 30.2043429,41.4514286 30.2043429,40.9906286 C30.2043429,40.5586286 29.8779429,40.2514286 29.4651429,40.2514286 C29.0235429,40.2514286 28.7547429,40.6546286 28.6779429,41.0770286 L27.3147429,40.6642286 C27.5163429,39.7042286 28.1883429,38.8114286 29.5899429,38.8114286 C30.8475429,38.8114286 31.7403429,39.6850286 31.7403429,40.7890286 C31.7403429,41.7106286 31.3659429,42.2770286 30.7035429,42.9586286 L29.3595429,44.3410286 L31.8747429,44.3410286 L31.8747429,45.6466286 L27.2763429,45.6466286 Z M37.3769143,43.4578286 C37.3769143,44.8498286 36.3497143,45.7618286 34.9001143,45.7618286 C33.5081143,45.7618286 32.7593143,45.0322286 32.5097143,44.0434286 L33.9017143,43.5634286 C34.0073143,43.9954286 34.3721143,44.3794286 34.8713143,44.3794286 C35.4665143,44.3794286 35.8409143,43.9858286 35.8409143,43.4482286 C35.8409143,43.0258286 35.5337143,42.5842286 34.8809143,42.5266286 L33.9881143,42.4306286 L33.9881143,41.4610286 L35.2073143,40.2322286 L32.9225143,40.2322286 L32.9225143,38.9266286 L37.0505143,38.9266286 L37.0505143,40.1362286 L35.6297143,41.4706286 C36.7049143,41.6722286 37.3769143,42.4498286 37.3769143,43.4578286 Z M40.6326857,45.6466286 L40.6326857,44.4178286 L37.8678857,44.4178286 L37.8678857,43.2274286 L40.7766857,38.9266286 L42.1686857,38.9266286 L42.1686857,43.1506286 L43.0902857,43.1506286 L43.0902857,44.4178286 L42.1686857,44.4178286 L42.1686857,45.6466286 L40.6326857,45.6466286 Z M39.2214857,43.1506286 L40.6326857,43.1506286 L40.6326857,41.1058286 L39.2214857,43.1506286 Z M45.9524571,45.7618286 C44.6084571,45.7618286 43.7924571,45.0610286 43.5620571,44.0722286 L44.9060571,43.6210286 C45.0596571,44.0914286 45.4052571,44.3794286 45.9428571,44.3794286 C46.4900571,44.3794286 46.9316571,43.9762286 46.9316571,43.3810286 C46.9316571,42.7858286 46.4900571,42.3922286 45.9524571,42.3922286 C45.5684571,42.3922286 45.1940571,42.5458286 45.0020571,42.9106286 L43.7252571,42.6898286 L44.1572571,38.9266286 L47.9396571,38.9266286 L47.9396571,40.2994286 L45.3092571,40.2994286 L45.1172571,41.4802286 C45.3476571,41.2690286 45.8180571,41.0866286 46.2884571,41.0866286 C47.6036571,41.0866286 48.4676571,42.0754286 48.4676571,43.4194286 C48.4676571,44.7442286 47.4116571,45.7618286 45.9524571,45.7618286 Z M51.5026286,45.7618286 C50.2066286,45.7618286 49.0930286,44.8114286 49.0930286,43.4578286 C49.0930286,42.8626286 49.3426286,42.2770286 49.6018286,41.8546286 L51.3682286,38.9266286 L53.1250286,38.9266286 L51.5218286,41.2306286 C51.6274286,41.2018286 51.7426286,41.1922286 51.8482286,41.1922286 C53.0002286,41.1922286 53.9122286,42.1138286 53.9122286,43.3906286 C53.9122286,44.7538286 52.8658286,45.7618286 51.5026286,45.7618286 Z M51.5026286,44.4466286 C52.0210286,44.4466286 52.3762286,43.9858286 52.3762286,43.4098286 C52.3762286,42.8434286 52.0210286,42.3922286 51.5026286,42.3922286 C50.9746286,42.3922286 50.6290286,42.8434286 50.6290286,43.4098286 C50.6290286,43.9858286 50.9746286,44.4466286 51.5026286,44.4466286 Z M54.96,45.6466286 L57.6096,40.2322286 L54.96,40.2322286 L54.96,38.9266286 L59.2128,38.9266286 L59.2128,40.1362286 L56.6016,45.6466286 L54.96,45.6466286 Z",
    id: "#1234567",
    fill: "#3C5A6B",
    fillRule: "nonzero",
    mask: "url(#reservation-number-mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9712931,24.6547465 C64.9712931,24.7523392 64.8919272,24.8317051 64.7943346,24.8317051 L61.7860397,24.8317051 C61.688447,24.8317051 61.6090811,24.7523392 61.6090811,24.6547465 L61.6090811,22.3542857 C61.6090811,22.2566931 61.688447,22.1773272 61.7860397,22.1773272 L64.7943346,22.1773272 C64.8919272,22.1773272 64.9712931,22.2566931 64.9712931,22.3542857 L64.9712931,24.6547465 Z M64.7529263,19.6114286 C65.0196913,19.6114286 65.2367309,19.8218323 65.2367309,20.0803687 L65.2358507,20.3184286 L65.6791272,20.3192627 C65.896275,20.3192627 66.07693,20.4757901 66.1143947,20.6821476 L66.1215235,20.761659 L66.1215235,23.0621198 C66.1215235,23.3064111 65.9234185,23.5045161 65.6791272,23.5045161 L65.6791272,23.5045161 L65.2367309,23.5045161 L65.2367309,24.6547465 C65.2367309,24.8990378 65.0386258,25.0971429 64.7943346,25.0971429 L64.7943346,25.0971429 L61.7860397,25.0971429 C61.5417484,25.0971429 61.3436433,24.8990378 61.3436433,24.6547465 L61.3436433,24.6547465 L61.3436433,23.5045161 L60.901247,23.5045161 C60.6569558,23.5045161 60.4588507,23.3064111 60.4588507,23.0621198 L60.4588507,23.0621198 L60.4588507,20.761659 C60.4588507,20.5173677 60.6569558,20.3192627 60.901247,20.3192627 L60.901247,20.3192627 L61.3428507,20.3184286 L61.3436433,20.0803687 C61.3436433,19.8218323 61.560683,19.6114286 61.827448,19.6114286 L64.7529263,19.6114286 Z M64.4404175,23.8584332 L62.1399567,23.8584332 C62.0666074,23.8584332 62.0072378,23.9178028 62.0072378,23.9911521 C62.0072378,24.0645014 62.0666074,24.123871 62.1399567,24.123871 L62.1399567,24.123871 L64.4404175,24.123871 C64.5137668,24.123871 64.5731364,24.0645014 64.5731364,23.9911521 C64.5731364,23.9178028 64.5137668,23.8584332 64.4404175,23.8584332 L64.4404175,23.8584332 Z M64.4404175,22.8851613 L62.1399567,22.8851613 C62.0666074,22.8851613 62.0072378,22.9445309 62.0072378,23.0178802 C62.0072378,23.0912295 62.0666074,23.1505991 62.1399567,23.1505991 L62.1399567,23.1505991 L64.4404175,23.1505991 C64.5137668,23.1505991 64.5731364,23.0912295 64.5731364,23.0178802 C64.5731364,22.9445309 64.5137668,22.8851613 64.4404175,22.8851613 L64.4404175,22.8851613 Z M64.7529263,19.8768664 L61.827448,19.8768664 C61.7070277,19.8768664 61.6090811,19.968177 61.6090811,20.0803687 L61.6088507,20.3184286 L64.9708507,20.3184286 L64.9712931,20.0803687 C64.9712931,19.968177 64.8733466,19.8768664 64.7529263,19.8768664 Z",
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#reservation-number-mask-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    mask: "url(#reservation-number-mask-2)",
    cx: 17.9605143,
    cy: 22.3542857,
    r: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CED6D9",
    mask: "url(#reservation-number-mask-2)",
    x: 15.7714286,
    y: 30.5828571,
    width: 40.4571429,
    height: 3.42857143,
    rx: 1.71428571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    mask: "url(#reservation-number-mask-2)",
    x: 21.7524162,
    y: 20.9828571,
    width: 22.9468898,
    height: 2.74285714,
    rx: 1.37142857
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#reservation-number-mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.771429, 49.876114)",
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CED6D9",
    x: 0,
    y: 0,
    width: 47.7148364,
    height: 3.42857143,
    rx: 1.71428571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CED6D9",
    x: 0,
    y: 6.85714286,
    width: 43.6530435,
    height: 3.42857143,
    rx: 1.71428571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CED6D9",
    x: 0,
    y: 13.7142857,
    width: 44.9862225,
    height: 3.42857143,
    rx: 1.71428571
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CED6D9",
    x: 0,
    y: 20.5714286,
    width: 35.6571429,
    height: 3.42857143,
    rx: 1.71428571
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(3.768100, 41.272319)",
    stroke: "#FFD00A",
    strokeDasharray: "2,3",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.6857143,
    y1: 8.01956651,
    x2: 0.638024259,
    y2: 8.01956651,
    id: "Line-5",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8998148,
    y1: 13.2962759,
    x2: 0.85212476,
    y2: 13.2962759,
    id: "Line-5",
    strokeWidth: 1.25,
    transform: "translate(6.875970, 13.296276) rotate(-15.000000) translate(-6.875970, -13.296276) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8998148,
    y1: 2.79165216,
    x2: 0.85212476,
    y2: 2.79165216,
    id: "Line-5",
    strokeWidth: 1.25,
    transform: "translate(6.875970, 2.791652) scale(1, -1) rotate(-15.000000) translate(-6.875970, -2.791652) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationNumber);
export default __webpack_public_path__ + "static/media/reservation-number.6afe6773.svg";
export { ForwardRef as ReactComponent };